(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/jackpot-ribbon.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/partials/jackpot-ribbon.js');
"use strict";


const RibbonCorner = svs.ui.ReactRibbon.RibbonCorner;
const formatCurrency = svs.utils.format.Currency;
const JackpotRibbon = _ref => {
  let jackpotAmount = _ref.jackpotAmount;
  return React.createElement(RibbonCorner, {
    branding: "bingo",
    className: "bingo-card-jackpot-flerp",
    size: "700"
  }, React.createElement("span", null, "Jackpot"), React.createElement("span", {
    "aria-live": "polite"
  }, "".concat(formatCurrency(jackpotAmount), " kr")));
};
setGlobal('svs.bingo_react.components.bingoCard.JackpotRibbon', JackpotRibbon);

 })(window);